/**
 * 請求データ変更通知（Licenses → Billing 等の同期用）
 */
export const BILLING_DATA_CHANGED_EVENT = 'hub:billing-data-changed';

export function notifyBillingDataChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BILLING_DATA_CHANGED_EVENT));
}
